/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupDto as DigiworkMaitreDPosDtoGroupGroupDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';
import { UpdateGroupDto as DigiworkMaitreDPosDtoGroupUpdateGroupDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/update-group-dto';

export interface UpdateGroup$Params {
  servingAreaId: string;
      body?: DigiworkMaitreDPosDtoGroupUpdateGroupDto
}

export function updateGroup(http: HttpClient, rootUrl: string, params: UpdateGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>> {
  const rb = new RequestBuilder(rootUrl, updateGroup.PATH, 'put');
  if (params) {
    rb.path('servingAreaId', params.servingAreaId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>;
    })
  );
}

updateGroup.PATH = '/api/groups/{servingAreaId}';
